import type { ShareConfig } from '../../shared/types';

import { useIsMobileNativeShareCapable } from './shared/useIsMobileNativeShareCapable';

export function useInstagramStoriesAvailable(config: ShareConfig): boolean {
	return useIsMobileNativeShareCapable() && !!config.instagramStories?.enabled;
}
